module.exports = __webpack_public_path__ + "a28c855b0fa2f2ce7d40c6fb4a98c28d.pdf";